import { message } from 'antd';
import { useDispatch } from 'react-redux';
import { makeRequest, addEntities } from '@wappsto/redux';
import { useRequest, useMounted } from '@wappsto/blanket';
import { Trans } from 'react-i18next';
import { getRequestErrorMessage } from 'util/helpers';
import { useTranslation } from 'translations';
import updateUnreadNotificationCount from './updateUnreadNotificationCount';

const useNotificationStatus = (setUnreadNotifications) => {
  const { t } = useTranslation('features', 'notifications');
  let { request: countRequest } = useRequest('notifications_count_request');
  const dispatch = useDispatch();
  const mounted = useMounted();

  const getErrorMessage = (notification, result) => {
    const { message: errorMessage } = getRequestErrorMessage(result, t);
    message.open({
      key: `notificationUpdateError_${notification.meta.id}`,
      type: 'error',
      content: (
        <>
          <Trans i18nKey="notificationUpdateError" />
          <div>{errorMessage}</div>
        </>
      ),
    });
  };

  const updateNotificationStatus = (notification, status, data, showError) => {
    if (
      status &&
      notification.read !== status &&
      (status !== 'read' ||
        (notification.read !== 'denied' &&
          notification.read !== 'accepted' &&
          notification.read !== 'deleted'))
    ) {
      const options: any = {
        method: 'PATCH',
        url: `/notification/${notification.meta.id}`,
        body: {
          read: status,
        },
      };
      if (data) {
        options.body.custom = { data };
      }
      const promise = dispatch(makeRequest(options));
      promise
        .then((result) => {
          if (mounted.current) {
            if (result.ok && result.json) {
              if (result.json.read !== 'unread') {
                countRequest = updateUnreadNotificationCount(
                  notification.meta.id,
                  countRequest,
                  setUnreadNotifications,
                );
              }
            } else if (showError) {
              getErrorMessage(notification, result);
            }
          }
        })
        .catch(() => {
          if (showError) {
            getErrorMessage(notification, {});
          }
        });
      const notificationClone = { ...notification, read: status };
      dispatch(addEntities('notification', notificationClone, { reset: false }));
    }
  };

  return updateNotificationStatus;
};

export default useNotificationStatus;
